import { useCallback, useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { Pane, Paragraph, Button, toaster, ListIcon, Text, Spinner } from 'evergreen-ui';
import { useMutation, useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { PayPalScriptProvider, PayPalButtons, usePayPalScriptReducer } from '@paypal/react-paypal-js';
import { getSettings } from '../../queries/settings';
import { DayFilterCard, Spacer, Header, Switch, Support, InputField } from '../../components';
import { CustomButton } from './styles';
import { setPage } from '../../store/sessionSlice';
import { updateSettings } from '../../queries/settings';
import { requestInvoice } from '../../queries/subscription';
import { useNavigate } from 'react-router-dom';

const PaypalButton = ({ user, settings }) => {
  return (
    <PayPalButtons
      createOrder={(data, actions) => {
        return actions.order.create({
          application_context: {
            shipping_preference: 'NO_SHIPPING',
            brand_name: 'GrabKings',
          },
          purchase_units: [
            {
              invoice_id: user.email + '_' + new Date().getTime(),
              amount: {
                currency_code: 'GBP',
                value: settings.paypalSubscriptionPrice,
              },
              description: 'Grabkings Monthly Subscription',
            },
          ],
        });
      }}
      onApprove={(data, actions) => {
        return actions.order.capture().then(details => {
          toaster.success('Payment Successful', { duration: 5 });
          // console.log(details);
          // const name = details.payer.name.given_name;
          // alert(`Transaction completed by ${name}`);
        });
      }}
      style={{ layout: 'horizontal', color: 'blue', label: 'paypal', tagline: false }}
    />
  );
};

const Subscription = ({ settings, user }) => {
  const [invoiceEmail, setInvoiceEmail] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector(state => state.authentication.token);
  const requestInvoiceQuery = useMutation(requestInvoice, {
    useErrorBoundary: true,
    onSuccess: data => {
      if (!data || !data.ok) return toaster.danger('Something went wrong', { duration: 5 });
      navigate('/app/invoiceSentSuccess');
    },
  });
  const requestInvoiceCall = async () => {
    try {
      await requestInvoiceQuery.mutateAsync({ email: invoiceEmail, token });
    } catch (error) {
      console.log(error);
    }
  };
  const expiration = settings?.subscription?.expiration;
  let expirationText = 'No subscription';
  let shouldShowPaymentOptions = true;
  if (expiration) {
    const expirationDate = moment(expiration).format('DD/MM/YYYY');
    const status = moment(expiration).isSameOrBefore(moment(), 'day') ? 'Expired' : 'Ending';
    expirationText = `Subscription ${status} ${expirationDate}`;
    if (moment().add(7, 'days').isBefore(moment(expiration))) shouldShowPaymentOptions = false;
  }
  return (
    <Pane display="flex" flexDirection="column" padding={16}>
      <Text color="#E78850" fontWeight="bold" fontSize={16}>
        {expirationText}
      </Text>
      {!!shouldShowPaymentOptions && (
        <>
          <Text marginTop={18} marginBottom={16} color="#6D6E75">
            Please complete transaction before the expiration day to avoid interuptions in service.
          </Text>
          <InputField
            type="text"
            onChange={e => setInvoiceEmail(e.target.value)}
            value={invoiceEmail}
            placeholder="Enter Email Address"
            marginTop="5px"
            autocapitalize="none"
          />
          <CustomButton
            type="button"
            appearance="primary"
            height={58}
            width="100%"
            backgroundColor="#e78850"
            border="none"
            borderRadius={10}
            onClick={invoiceEmail && requestInvoiceCall}
            disabled={!invoiceEmail || requestInvoiceQuery.isLoading}
          >
            <Text color="#fcfdfd" fontWeight="bold" fontSize="16px">
              Request Invoice
            </Text>
          </CustomButton>
          <Text marginTop={18} color="#6D6E75">
            Enter the email address where you would like to recieve the Invoice.
          </Text>
        </>
      )}
    </Pane>
  );
};

export default Subscription;
